function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotepad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "46px",
    viewBox: "0 0 36 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,88.627451%,88.627451%)",
      fillOpacity: 1
    },
    d: "M 33.828125 46.65625 L 2.363281 46.65625 C 1.058594 46.652344 0.00390625 45.597656 0 44.296875 L 0 11.960938 C 0.00390625 10.660156 1.058594 9.605469 2.363281 9.605469 L 33.8125 9.605469 C 35.113281 9.605469 36.171875 10.660156 36.175781 11.960938 L 36.175781 44.277344 C 36.179688 44.902344 35.9375 45.507812 35.496094 45.953125 C 35.058594 46.402344 34.457031 46.652344 33.828125 46.65625 Z M 33.828125 46.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 33.828125 43.339844 L 2.363281 43.339844 C 1.058594 43.335938 0.00390625 42.28125 0 40.980469 L 0 8.644531 C 0.00390625 7.34375 1.058594 6.289062 2.363281 6.285156 L 33.8125 6.285156 C 35.113281 6.289062 36.171875 7.34375 36.175781 8.644531 L 36.175781 40.960938 C 36.179688 41.585938 35.9375 42.191406 35.496094 42.636719 C 35.058594 43.082031 34.457031 43.335938 33.828125 43.339844 Z M 33.828125 43.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(43.921569%,81.568627%,92.54902%)",
      fillOpacity: 1
    },
    d: "M 33.8125 40.132812 L 2.363281 40.132812 C 1.058594 40.128906 0.00390625 39.074219 0 37.773438 L 0 5.4375 C 0.00390625 4.136719 1.058594 3.082031 2.363281 3.078125 L 33.8125 3.078125 C 35.113281 3.082031 36.171875 4.136719 36.175781 5.4375 L 36.175781 37.753906 C 36.179688 38.382812 35.933594 38.988281 35.488281 39.433594 C 35.046875 39.882812 34.441406 40.132812 33.8125 40.132812 Z M 33.8125 40.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 19.945312 19.300781 L 6.839844 19.300781 C 6.023438 19.300781 5.363281 18.640625 5.363281 17.828125 C 5.363281 17.011719 6.023438 16.355469 6.839844 16.351562 L 19.945312 16.351562 C 20.757812 16.355469 21.417969 17.011719 21.421875 17.828125 C 21.417969 18.640625 20.757812 19.300781 19.945312 19.300781 Z M 19.945312 19.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 29.546875 26.121094 L 6.835938 26.121094 C 6.019531 26.121094 5.359375 25.460938 5.355469 24.648438 C 5.359375 23.832031 6.019531 23.175781 6.835938 23.171875 L 29.546875 23.171875 C 30.363281 23.175781 31.023438 23.832031 31.023438 24.648438 C 31.023438 25.460938 30.363281 26.121094 29.546875 26.121094 Z M 29.546875 26.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 29.546875 32.574219 L 6.835938 32.574219 C 6.019531 32.570312 5.359375 31.914062 5.355469 31.097656 C 5.359375 30.285156 6.019531 29.625 6.835938 29.625 L 29.546875 29.625 C 30.363281 29.625 31.023438 30.285156 31.023438 31.097656 C 31.023438 31.914062 30.363281 32.570312 29.546875 32.574219 Z M 29.546875 32.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 8.03125 6.46875 L 7.273438 6.46875 C 6.304688 6.46875 5.519531 5.683594 5.519531 4.71875 L 5.519531 1.75 C 5.519531 0.78125 6.304688 0 7.273438 0 L 8.03125 0 C 9 0 9.785156 0.78125 9.785156 1.75 L 9.785156 4.71875 C 9.789062 5.183594 9.605469 5.628906 9.277344 5.960938 C 8.945312 6.289062 8.5 6.472656 8.03125 6.46875 Z M 8.03125 6.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 18.742188 6.46875 L 17.984375 6.46875 C 17.015625 6.46875 16.230469 5.683594 16.230469 4.71875 L 16.230469 1.75 C 16.230469 0.78125 17.015625 0 17.984375 0 L 18.742188 0 C 19.710938 0 20.496094 0.78125 20.496094 1.75 L 20.496094 4.71875 C 20.5 5.183594 20.316406 5.628906 19.988281 5.960938 C 19.65625 6.289062 19.210938 6.472656 18.742188 6.46875 Z M 18.742188 6.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,36.862745%,44.705882%)",
      fillOpacity: 1
    },
    d: "M 29.269531 6.46875 L 28.511719 6.46875 C 27.542969 6.46875 26.757812 5.683594 26.757812 4.71875 L 26.757812 1.75 C 26.757812 0.78125 27.542969 0 28.511719 0 L 29.269531 0 C 30.238281 0 31.023438 0.78125 31.023438 1.75 L 31.023438 4.71875 C 31.027344 5.183594 30.84375 5.628906 30.511719 5.960938 C 30.183594 6.289062 29.734375 6.472656 29.269531 6.46875 Z M 29.269531 6.46875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.e1bde48e.svg";
export { ForwardRef as ReactComponent };